/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/


import React from "react";
import "./HomeSection.css";
import heroImage from "../../imgs/hero-handyman.jpg"; // replace with your image path

function Hero() {
  return (
    <section id="home" className="hero">
      {/* Left side image */}
      <div className="hero__image">
        <div className="hero__image-frame">
          <img src={heroImage} alt="Northwoods Handy craftsman in his workshop" />
        </div>
      </div>

      {/* Right side content */}
      <div className="hero__content">
        <span className="hero__eyebrow">Residential &amp; Commercial</span>

        <h1 className="hero__title">
          Handy <br /> Man.
        </h1>

        <p className="hero__text">
          No job is too big or too small for me. I'm available for both
          residential and commercial needs. Give me a call and let me take care
          of all your handyman needs!
        </p>

        <button className="hero__btn">Let's Work</button>
      </div>
    </section>
  );
}

export default Hero;